import React from "react";

export default function Header({ contractHolderCount, contractCount }) {
  return (
    <>
      <h1 className="page_title" role="banner" tabIndex="-1">
        NASA SEWP Small Business Breakdown
      </h1>
      <div className="panel-body">
        <div className="col-xs-12">
          <strong>{`Total number of Contract Holders: ${contractHolderCount}`}</strong>
        </div>
        <div className="col-xs-12">
          <strong>{`Total number of Contracts: ${contractCount}`}</strong>
        </div>
      </div>
    </>
  );
}
